/**
 * One ranking entry as stored in `action_view_priority_config`'s `ranking`
 * JSONB (row `id = 'active'`). Moved here (2026-09-24, bead
 * terra-signals-tab-ui-signals-tab-pr1-2sx.8) from
 * `src/services/flow/priority-config.ts` so both the server reader and
 * `web/app-home` (the Signals tab's ranking display) can import the SAME
 * declaration without the client pulling in a server module — `src/shared/
 * schemas/` is the only place both may import from. `src/services/flow/
 * priority-config.ts` re-exports `PriorityRankingEntrySchema` /
 * `PriorityRankingEntry` from here so existing server imports keep
 * resolving to this one object (`terra/no-duplicate-schema-name`).
 *
 * Named distinctly from Action View's `RankingEntrySchema`
 * (`mini-apps/action-view/types.ts`) — core/shared code must not import
 * mini-app code (mini-apps/CLAUDE.md), so the two schemas are intentionally
 * separate declarations kept in lockstep by convention, not by import.
 *
 * `subtype` may be missing/empty in legacy rows; `playType` is optional.
 * `active` defaults to true when absent so a legacy entry written before
 * the active flag existed still ranks.
 */
import { z } from 'zod';

export const PriorityRankingEntrySchema = z.object({
  type: z.string(),
  subtype: z.string().default(''),
  playType: z.string().optional(),
  active: z.boolean().default(true),
});
export type PriorityRankingEntry = z.infer<typeof PriorityRankingEntrySchema>;
